export default "__VITE_ASSET__a2cb43b0__"